import { render, staticRenderFns } from "./BlogSectionSimpleGrid.vue?vue&type=template&id=39be4743"
import script from "./BlogSectionSimpleGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogSectionSimpleGrid.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports